import React, { Component } from 'react';
import TourLogoWrapper from '../TourLogoWrapper/TourLogoWrapper';
import AFramePanorama from '../../../AFrame/AFramePanorama';
import AFrameVideo from '../../../AFrame/AFrameVideo';
import AframeStatic from '../../../AFrame/AframeStatic';
import MapWrapper from '../../../Map/MapWrapper/MapWrapper';
import MainMediaControls from '../MainMediaControls/MainMediaControls';
import StopMarkers from './StopMarkers/StopMarkers';
import { customGaEvent } from '../../../../utils/ga';
import toggleElementFullscreen from '../../../../utils/toggleElementFullscreen';
import detectWebGLContext from '../../../../utils/webglSupport';
import * as constants from '../../../../constants';
import { CaptureHigherEd } from '../../../../utils/captureHigherEdHelpers';

class ViewMainMedia extends Component {
  constructor() {
    super();
    this.state = {
      imageHeight: 0,
    };
  }

  componentDidMount() {
    const { history, currentStop = {} } = this.props;

    const { mainMediaType } = currentStop;

    detectWebGLContext()
      .then(res => res)
      .catch(({ message }) => {
        console.warn(message);
        history.push('/share/error/unsupported-browser');
      });

    if (mainMediaType === constants.IMAGES) {
      const viewWrapper = document.getElementById('view-wrapper');
      // sets height of image for Cloudinary API call depending on view wrapper height
      if (viewWrapper) {
        this.setState({ imageHeight: viewWrapper.offsetHeight });
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      activeStop,
      miniMapView,
      radarPos,
      panoHasKeyboardControl,
    } = this.props;
    const { imageHeight } = this.state;
    return (
      activeStop !== nextProps.activeStop ||
      miniMapView !== nextProps.miniMapView ||
      radarPos !== nextProps.radarPos ||
      imageHeight !== nextState.imageHeight ||
      panoHasKeyboardControl !== nextState.panoHasKeyboardControl
    );
  }

  componentDidUpdate(prevProps) {
    const { currentStop = {}, captureHigherEdTrackingId } = this.props;
    if (currentStop !== prevProps.currentStop && captureHigherEdTrackingId) {
      CaptureHigherEd.logPageView();
    }

    const { mainMediaType } = currentStop;
    if (mainMediaType === constants.IMAGES) {
      const viewWrapper = document.getElementById('view-wrapper');
      // sets height of image for Cloudinary API call depending on view wrapper height
      if (viewWrapper && this.state.imageHeight !== viewWrapper.offsetHeight) {
        this.setState({ imageHeight: viewWrapper.offsetHeight });
      }
    }
    const aframeVRButton = document.querySelector('.a-enter-vr-button');
    const aframeARButton = document.querySelector('.a-enter-ar-button');
    if (aframeVRButton) aframeVRButton.id = 'aframe-vr-button';
    if (aframeARButton) aframeARButton.id = 'aframe-ar-button';
  }

  openPopup = stopData => {
    const { stopName, origin } = stopData;
    customGaEvent({
      action: origin,
      label: stopName,
    });
  };

  render() {
    const {
      miniMapView,
      allStops,
      tourStops,
      currentTour = {},
      currentTour: {
        styles: { primaryColor },
      },
      currentStop = {},
      tier,
      publicTour,
      toggleShareModal,
      getPanoRotation,
      activeStop,
      changeStop,
      path,
      tourId,
      switchMapView,
      radarPos,
      mapToken,
      history,
      setYPosition,
      checkLogoURL,
      panos,
      images,
      panoHasKeyboardControl,
      stopDescriptionMinimized,
      isMainMediaPlaying,
      toggleMainMediaStatus,
      showPanoControls,
      togglePanoControls,
      aid,
      previewTour,
      accountPermissions,
    } = this.props; // default to panos if mainMediaType prop does not exist

    const { mainMediaType = constants.PANOS } = currentStop;
    const analyticsObj = { publicTour, currentTour };
    const mapControls = {
      nav: { show: true, pos: 'top-right' },
      layers: { show: true, pos: 'top-right' },
      geolocate: { show: true, pos: 'top-right' },
      geocoder: { show: false, pos: 'top-left' },
    };

    const mainMedia =
      mainMediaType === constants.PANOS ||
      mainMediaType === constants.VIDEOS360;

    let panoAltText = '';
    let imageAltText = '';
    // the alt text for panos and images are only found within their respective objects
    // panoId relates to both images and panos
    if (currentStop.panoId && panos[currentStop.panoId]) {
      panoAltText = panos[currentStop.panoId].alt
        ? panos[currentStop.panoId].alt
        : '';
    }
    if (currentStop.panoId && images[currentStop.panoId]) {
      imageAltText = images[currentStop.panoId].alt
        ? images[currentStop.panoId].alt
        : '';
    }

    const isMobile = window.innerWidth < 1025;
    let shouldAutoRotate;

    if (typeof sessionStorage !== 'undefined') {
      // check sessionStorage for auto-rotate preference
      try {
        const storedAutoRotate = sessionStorage.getItem('autoRotate');
        shouldAutoRotate = storedAutoRotate !== null ? JSON.parse(storedAutoRotate) : currentStop.autoRotate;
      } catch (error) {
        // if JSON.parse fails, fall back to the current stop's autoRotate setting
        shouldAutoRotate = currentStop.autoRotate;
      }
    } else {
      // fall back to the current stop's autoRotate setting when sessionStorage is not available
      shouldAutoRotate = currentStop.autoRotate;
    }

    let panoUrl;
    if (mainMediaType === constants.PANOS) {
      if (
        currentStop.panoId &&
        panos[currentStop.panoId] &&
        panos[currentStop.panoId].url !== undefined
      ) {
        panoUrl = panos[currentStop.panoId].url;
      } else {
        panoUrl = constants.DEFAULTPANO;
      }
    }

    return (
      <React.Fragment>
        {miniMapView === 'map' && currentStop && (
          <React.Fragment>
            {mainMediaType === constants.VIDEOS360 && (
              <AFrameVideo
                activeStop={activeStop}
                autoLoop={currentStop.autoLoop}
                autoRotate={shouldAutoRotate}
                autoRotateDirection={currentStop.autoRotateDirection}
                changeStop={changeStop}
                checkLogoURL={checkLogoURL}
                closeShareModal={toggleShareModal}
                currentStop={currentStop}
                getPanoRotation={getPanoRotation}
                history={history}
                id={currentStop.panoId}
                initialView={currentStop.panoInitialView}
                isMainMediaPlaying={isMainMediaPlaying}
                isMobile={isMobile}
                miniMapView={miniMapView}
                northView={currentStop.panoNorthView}
                primaryColor={primaryColor}
                publicTour={publicTour}
                ratio={currentStop.ratio}
                setYPosition={setYPosition}
                showPanoControls={showPanoControls}
                showVRMode={currentTour.showVRMode}
                src={currentStop.panoUrl}
                stopDescriptionMinimized={stopDescriptionMinimized}
                tier={tier}
                toggleMainMediaStatus={toggleMainMediaStatus}
                togglePanoControls={togglePanoControls}
                tourData={currentTour}
                tourPublished={currentTour.published}
                viewOnly
                aid={aid}
                accountPermissions={accountPermissions}
              />
            )}
            {mainMediaType === constants.PANOS && (
              <AFramePanorama
                activeStop={activeStop}
                autoRotate={shouldAutoRotate}
                autoRotateDirection={currentStop.autoRotateDirection}
                changeStop={changeStop}
                checkLogoURL={checkLogoURL}
                closeShareModal={toggleShareModal}
                cube
                currentStop={currentStop}
                getPanoRotation={getPanoRotation}
                history={history}
                initialView={currentStop.panoInitialView}
                isMainMediaPlaying={isMainMediaPlaying}
                isMobile={isMobile}
                miniMapView={miniMapView}
                northView={currentStop.panoNorthView}
                panoAltText={panoAltText}
                panoHasKeyboardControl={panoHasKeyboardControl}
                primaryColor={primaryColor}
                publicTour={publicTour}
                ratio={currentStop.ratio}
                rotation={{ x: 4, y: 4, z: 2 }}
                setYPosition={setYPosition}
                showPanoControls={showPanoControls}
                showTransitionLogo={tier === 'starter'}
                showVRMode={currentTour.showVRMode}
                src={panoUrl}
                tier={tier}
                toggleMainMediaStatus={toggleMainMediaStatus}
                togglePanoControls={togglePanoControls}
                tourData={currentTour}
                tourPublished={currentTour.published}
                aid={aid}
                accountPermissions={accountPermissions}
                viewOnly
              />
            )}
            {!mainMedia && (
              <React.Fragment>
                {currentTour && (
                  <TourLogoWrapper
                    currentTour={currentTour}
                    tier={tier}
                    checkLogoURL={checkLogoURL}
                    publicTour={publicTour}
                    tourId={tourId}
                    aid={aid}
                  />
                )}
                <AframeStatic
                  panoId={currentStop.panoId}
                  height={this.state.imageHeight}
                  alt={imageAltText}
                  view
                  tabIndex={0}
                  currentTour={currentTour}
                  currentStop={currentStop}
                  changeStop={changeStop}
                  isMainMediaPlaying={isMainMediaPlaying}
                  previewTour={previewTour}
                  accountPermissions={accountPermissions}
                  primaryColor={primaryColor}
                />
                <MainMediaControls
                  tier={tier}
                  primaryColor={primaryColor}
                  tourPublished={currentTour.published}
                  miniMapView={miniMapView}
                  closeShareModal={toggleShareModal}
                  stopIds={currentTour && currentTour.stopIds}
                  stops={allStops}
                  setYPosition={setYPosition}
                  toggleFullScreen={() => toggleElementFullscreen('.a-canvas')}
                  isMobile={isMobile}
                  viewOnly
                  staticImg
                />
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        {miniMapView !== 'map' && currentStop && (
          <React.Fragment>
            <MapWrapper
              miniMapView={miniMapView}
              path={path}
              tier={tier}
              addControls={mapControls}
              analytics={analyticsObj}
              mapStyle={currentTour.tourMapStyle}
              mapRendering={currentTour.mapRenderingUrl}
              tourId={currentTour.id}
              mapToken={mapToken}
            />
            <StopMarkers
              tourStops={tourStops}
              activeStop={activeStop}
              radarPos={radarPos}
              changeStop={changeStop}
              switchMapView={switchMapView}
              tourId={tourId}
            />
            <MainMediaControls
              tier={tier}
              primaryColor={primaryColor}
              tourPublished={currentTour.published}
              miniMapView={miniMapView}
              closeShareModal={toggleShareModal}
              toggleFullScreen={() => toggleElementFullscreen('.a-canvas')}
              isMobile={window.innerWidth < 1025}
              stops={allStops}
              stopIds={currentTour.stopIds}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default ViewMainMedia;
